import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import hydrate from './components/hydrate'
import { currentRoute } from './stores/router'
import getTrackingId from './lib/get-tracking-id'
import { name, version } from '../package.json'
import tracker from '@nrk/core-analytics'

import '@/styles/global.css'
import '@/styles/global.module.css'
import { title } from './stores/title'

const tag = getElementTag(name, version)

class AppElement extends BaseElement {
  name = tag

  async connectedCallback() {
    // setup
    tracker('initialize', {
      parentId: this.metadata.parentId,
      ga: this.dataset.gaPropertyId,
    })

    tracker('context', {
      contentId: this.metadata.selfId,
      publishDate: this.metadata.published,
    })

    hydrate(this, this.preloadedState)

    if (this.preloadedState.preview) {
      import('./sanity-preview').then((m) => m.init())
    }

    currentRoute.subscribe((route) => {
      tracker('recommendations', { contentId: getTrackingId(route) })
      tracker('pageview', { tnsSection: this.preloadedState.tnsSection })
    })
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
